import KeywordSettings from './KeywordSettings';
import "./KeywordSettings.scss";

export default KeywordSettings;